export default __webpack_public_path__ + "static/fso-33242ef5d6e0b1276306dd09ff0119f3.png";